/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import {
    Spinner, Modal,
    ModalBody, ModalFooter } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
    BlockDes,
    BlockHead,
    PaginationComponent
} from "../../../../components/Component";
import Head from "../../../../layout/head/Head";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionS from "../../../components/DynmicOption/OptionS";
import OptionC from "../../../components/DynmicOption/OptionC";
import OptionM from "../../../components/DynmicOption/OptionM";
import loadspinner from "../../../../assets/images/spinner.gif"

const ES2DataReport = ({ ...props }) => {
    const [itemPerPage, setItemPerPage] = useState(500);
    const [currentPage, setCurrentPage] = useState(1);
    const [Statee, setStatee] = useState([]);
    const [DataCount, setDataCount] = useState(0)
    const [load, setload] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [nextloading, setnextloading] = useState(false);
    const today = new Date();
    const tableRef = useRef(null);
    const tableRef1 = useRef(null);
    const [generate1, setgenerate1] = useState(true);
    const [gen, setgen] = useState(0);
    const [time, settime] = useState(0);
    const [id, setid] = useState(0);
    const [modal, setmodal] = useState(false);
    const [loadmain, setloadmain] = useState(true);
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() + 1 : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth() + 1] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 1,
        state: -1
    });

    const paginate = (pageNumber) => {
        // Validate that a valid user or "All" option has been selected
        if (formData.state === -1) {
            alert("Please select a user or 'All' option to view data.");
            setnextloading(false);
            return;
        }

        setnextloading(true)
        setStatee([])
        var mainid = document.getElementById("datashow");
        mainid.scrollIntoView();
        //console.log(mainid);
        setCurrentPage(pageNumber)
        if (formData.state !== "0") { getdata3(pageNumber) } else { getdataAll(pageNumber) }


    };
    const [states, setstates] = useState("")
    const onInputChange = (e) => {
        var index = e.nativeEvent.target.selectedIndex;
        setstates(e.nativeEvent.target[index].text)
        setFormData({ ...formData, [e.target.name]: e.target.value });
   
    };
    const onInputChange2 = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const onInputChange3 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };
    const getdata3 = async (pageno) => {
        const sendData = {

            EmploymentRefId: Number(2),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(itemPerPage),
            Skip: Number((pageno - 1) * itemPerPage)
        }
        
        // Validate UserId before sending request
        if (sendData.UserId < 1) {
            console.error('Invalid UserId:', sendData.UserId);
            setStatee([]);
            setload(true);
            setmodal(false);
            setnextloading(false);
            alert("Please select a state.");
            return;
        }

        console.log('Sending request with data:', sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES2MIS', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data) {
                        const datamain = [...data]
                        setStatee(data)
                        if (data.length === 0) {
                            setmodal(false)
                        }
                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)
                })
            .catch(error => {
                console.error('Error fetching data:', error);
                setload(true);
                setmodal(false);
                setnextloading(false);
            })


    };

    const getdatacount = async () => {
        const sendData = {

            EmploymentRefId: Number(2),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/COUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data !== null && data !== undefined) {
                        setDataCount(data)
                    }
                })
            .catch(error => {
                console.error('Error fetching count:', error);
            })


    };

    const getdatacountAll = async () => {
        const sendData = {

            EmploymentRefId: Number(2),
            UserId: Number(0),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ALLCOUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data !== null && data !== undefined) {
                        setDataCount(data)
                    }
                })
            .catch(error => {
                console.error('Error fetching all count:', error);
            })


    };


    const getdataAll = async (page) => {
        const sendData = {
            EmploymentRefId: Number(2),
            UserId: Number(0),
            StateId: formData.state === "0" ? null : Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(itemPerPage),
            Skip: Number((page - 1) * itemPerPage)
        }
       // console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES2MISAll', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data) {
                        setStatee(data)
                        if (data.length === 0) {
                            setmodal(false)
                        }
                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)
                })
            .catch(error => {
                console.error('Error fetching all data:', error);
                setload(true);
                setmodal(false);
                setnextloading(false);
            })


    };

    const generate = async () => {
        // Validate that a valid user has been selected
        if (formData.state === -1) {
            alert("Please select a state.");
            return;
        }

       sessionStorage.setItem("NumberES2", 0)
        setgen(gen + 1)
        setloadmain(false)
        setmodal(true)
        getdatacount()
        getdata3(1)
        setgenerate1(false)


    }
    const generateAll = async () => {
        sessionStorage.setItem("NumberES2", 0)
        setgen(gen + 1)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdatacountAll()
        getdataAll(1)
        setgenerate1(false)



    }

    const paginateData = Statee.slice(
        (currentPage - 1) * itemPerPage,
        currentPage * itemPerPage
    )


    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <BlockHead size="lg">

                            <BlockDes className="text-soft">
                        <Row >

                            <Col xl="3" md="3">
                                <td >
                                    <h5 style={{ color: '#798bff' }}>DGE Dashboard</h5>
                                </td>
                            </Col>
                            <Col xl="3" md="3" >

                                <label style={{ color: 'black', fontSize: 15 }}>  State :  <label style={{ fontWeight: 'bold' }}><OptionS catid="43" onInputChange={onInputChange} namemain="state" mainid="state" /></label></label>
                         </Col>
                          <Col xl="3" md="3" >

                                <label style={{ color: 'black', fontSize: 15 }}> From: <label style={{ fontWeight: 'bold' }}><OptionC onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>
                            </Col> 
                             <Col xl="3" md="3" >

                                <label style={{ color: 'black', fontSize: 15 }}> To: <label style={{ fontWeight: 'bold' }}><OptionM onInputChange={onInputChange3} year={formData.year} month={formData.month} /></label></label>
                            </Col>
                            <Col xl="3" md="3" >
                                 {formData.state !== String(0) ?  <Button color="success" style={{ marginTop: 10 }} onClick={() => generate()}>Generate</Button>:
                                            <Button color="success" style={{ marginTop: 10 }} onClick={() => generateAll()}>Generate</Button>}

                             </Col>
                                </Row>
                            </BlockDes>
                        </BlockHead>
                                <hr />
                        {generate1 ? <h3>Please Select State and Month to Generate Report!!</h3> :
                            <>
                                {modal ? <div>
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Spinner size="xl" />
                                    </div>
                                </div> : null}
                                <div style={{ visibility: modal ? "hidden" : "visible" }}>
                                <Row>
                                    <Col md="2" lg="3">
                                        <h4 style={{ marginBottom: 40 }}>Employment Report (ES2) </h4>
                                    </Col>
                                    <Col md="2" lg="3">

                                    </Col>
                                    {loadmain?
                                        <Col md="2" lg="3">
                                            <Button disabled style={{ float: "right", marginBottom: 10 }} color="danger" ><Icon class="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>
                                        
                                        </Col> :
                                    
                                        <Col md="2" lg="3">
                                            <DownloadTableExcel
                                                filename="ES2 Report Abbreviation"
                                                sheet="users"
                                                currentTableRef={tableRef1.current}
                                            >
                                                <Button style={{ float: "right", marginBottom: 10 }} color="warning" ><Icon class="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>
                                            </DownloadTableExcel>
                                        </Col>}

                                    {loadmain?
                                        <Col md="2" lg="3">"


                                            <Button disabled style={{ float: "right" }} color="danger" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                         
                                        </Col> :
                                        <Col md="2" lg="3">"

                                            <DownloadTableExcel
                                                filename="ES2 Report"
                                                sheet="users"
                                                currentTableRef={tableRef.current}
                                            >
                                                <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                            </DownloadTableExcel>
                                        </Col>}
                                </Row>

                                    <Modal isOpen={false} fullscreen="xl" size="xl" >
                                    <ModalBody>

                                        <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <img src={loadspinner} alt="load" />
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="danger" onClick={() => window.location.reload()}>
                                            Stop Report
                                        </Button>{' '}

                                    </ModalFooter>
                                </Modal>


                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                    <table className="table table-orders" ref={tableRef1} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                                        <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0 }}>


                                            <tr> <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                Description

                                            </th>
                                                <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                    Abbreviation

                                                </th>
                                                <br />
                                                <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                    Description

                                                </th>
                                                <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                    Abbreviation

                                                </th>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Registration during the month</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Below 10th class</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >X</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Gender</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>

                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "200px" }} >10th class passed</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", alignItems: "center" }} > =X</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Men</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Women</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} > W</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Transgender</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TG</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Graduate</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >G</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Category</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Post Graduate</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PG</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Caste</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SC</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Diploma holder in Engineering Technology and Others</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >DIP</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Tribe</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ST</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Others Professional</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OTHER</td>

                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                                <br />
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TR</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Placement during the month</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Gender</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Men</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M_P</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Women</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >W_P</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Transgender</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TG_P</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Category</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Caste</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SC_P</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Tribe</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ST_P</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC_P</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Tribe</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ST_P</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Live Register upto the month</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Gender</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Men</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M_LR</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Age upto 19 years</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M_LR_19</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Age 20-39 years</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M_LR_20-39</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Age 40 years and above</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M_LR_40A</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Women</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >W_LR</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Age upto 19 years</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >W_LR_19</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Age 20 to 39 years</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >W_LR_20-39</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Age 40 years and above</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >W_LR_40A</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Transgender</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TG_LR</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Category</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Caste</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SC_LR</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Tribe</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ST_LR</td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                                <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC_LR</td>
                                            </tr>

                                        </thead>

                                    </table>

                                </div>
                                <div className="card-inner-group" style={{ border: '4px solid black', padding: 2 }}>

                                    <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                        <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                            <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                    <tr>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Form: ES2 Report

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            State: {states}

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            From Date: {month1[formData.month]} {formData.year}

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            To Date: {month1[formData.tomonth]} {formData.toyear}

                                                        </th>
                                                    </tr>
                                                </thead>
                                            </div>
                                            <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                <tr>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        S. No.

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        Year

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        Month

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        State
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        Employment Exchange

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"M_R<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_R=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_R=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_R_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_R_PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_R_DIP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_R_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_TR

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"W_R<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_R=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_R=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_R_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_R-PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_R_DIP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_R_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_TR

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"TG_R<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_R=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_R=XII
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_R_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_R-PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_R_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_R_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_TR
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"SC_R<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_R=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_R=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_R_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_R_PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_R_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_R_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_TR
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"ST_R<X"}
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_R=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_R=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_R_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_R-PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_R_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_R_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_TR
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"OBC_R<X"}
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_R=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_R=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_R_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_R_PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_R_DIP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_R_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_TR
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"M_P<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_P=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_P=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_P_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_P-PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_P_DIP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_P_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_TP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"W_P<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_P=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_P=XII
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_P_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_P_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_P_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_P_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_TP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"TG_P<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_P=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_P=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_P_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_P_PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_P_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_P_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_TP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"SC_P<X"}
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_P=X
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_P=XII
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_P_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_P_PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_P_DIP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_P_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_TP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"ST_P<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_P=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_P=XII
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_P_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_P_PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_P_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_P_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_TP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"OBC_P<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_P=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_P=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_P_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_P_PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_P_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_P_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_TP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"M_LR<X"}
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=X
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=XII
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                         M_LR-PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_TLR_19
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"M_LR<X_19"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=X_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=XII_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_G_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR-PG_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_DIP_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_OTHER_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_TLR_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"M_LR<X_20-39"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=X_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=XII_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_R_G_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR-PG_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_DIP_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_OTHER_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_TLR_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"M_LR<X_40A"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=X_40A

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR=XII_40A

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_G_40A

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_PG_40A

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_DIP_40A

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_LR_OTHER_40A

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        M_TLR_40A

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"W_LR<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR-PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_DIP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_OTHER

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_TLR

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"W_LR<X_19"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=X_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=XII_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_G_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR-PG_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_DIP_19
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_OTHER_19

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_19
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"W_LR<X_20-39"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=X_20-39
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=XII_20-39
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_G_20-39
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_PG_20-39
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_DIP_20-39
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_OTHER_20-39
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_TLR_20-39

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"W_LR<X_40"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=X_40

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR=XII_40

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_G_40

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_PG_40

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_DIP_40

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_LR_OTHER_40

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        W_TLR_40

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"TG_LR<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_LR=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_LR=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_LR_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_LR-PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_LR_DIP

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_LR_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        TG_TLR
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"SC_LR<X"}
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_LR=X
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_LR=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_LR_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_LR_PG

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_LR_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_LR_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        SC_TLR
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"ST_LR<X"}
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_LR=X
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_LR=XII
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_LR_G
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_LR_PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_LR_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_LR_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        ST_TLR
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        {"OBC_LR<X"}

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_LR=X

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_LR=XII

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_LR_G

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_LR_PG
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_LR_DIP
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_LR_OTHER
                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        OBC_TLR
                                                    </th>
                                                   


                                                </tr>


                                            </thead>

                                            <tbody>
                                                    <td id="datashow" style={{ visibility: "hidden", height: 0, width: 0 }}></td>
                                                    {nextloading ? <div>
                                                        <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                            <Spinner size="xl" />
                                                        </div>
                                                    </div> : load ? (Statee.length !== 0 && nextloading === false ? Statee.map((details, index) =>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>{(itemPerPage * (currentPage - 1)) + index + 1}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {details.yearId}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {month1[details.monthId]}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {details.state}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                <b>  {details.center}</b>
                                                            </td>
                                                            {details.eSdata.map((data) =>
                                                                <>
                                                                    {data.parametersId === 32  ?

                                                                        <>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {data.below10thClass3 === null ? 0 : data.below10thClass3}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >

                                                                                {data._10thClassPassed4 === null ? 0 : data._10thClassPassed4}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {data._102Passed5 === null ? 0 : data._102Passed5}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                                                                                {data.graduate6 === null ? 0 : data.graduate6}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                <label> {data.postGraduate7 === null ? 0 : data.postGraduate7}</label>
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.diplomaHolderInEngineeringTechnologyAndOthers8 === null ? 0 : data.diplomaHolderInEngineeringTechnologyAndOthers8}

                                                                            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.otherProfessional9 === null ? 0 : data.otherProfessional9}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.total10 === null ? 0 : data.total10}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {details.below10thClass3t1 === null ? 0 : details.below10thClass3t1}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >

                                                                                {details._10thClassPassed4t1 === null ? 0 : details._10thClassPassed4t1}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {details._102Passed5t1 === null ? 0 : details._102Passed5t1}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                                                                                {details.graduate6t1 === null ? 0 : details.graduate6t1}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                <label> {details.postGraduate7t1 === null ? 0 : details.postGraduate7t1}</label>
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {details.diplomaHolderInEngineeringTechnologyAndOthers8t1 === null ? 0 : details.diplomaHolderInEngineeringTechnologyAndOthers8t1}

                                                                            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {details.otherProfessional9t1 === null ? 0 : details.otherProfessional9t1}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {details.total10t1 === null ? 0 : details.total10t1}

                                                                            </td></> : (data.parametersId === 38 ?
                                                                            <>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                    {data.below10thClass3 === null ? 0 : data.below10thClass3}


                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >

                                                                                    {data._10thClassPassed4 === null ? 0 : data._10thClassPassed4}

                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                    {data._102Passed5 === null ? 0 : data._102Passed5}


                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                                                                                    {data.graduate6 === null ? 0 : data.graduate6}

                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                    <label> {data.postGraduate7 === null ? 0 : data.postGraduate7}</label>
                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                    {data.diplomaHolderInEngineeringTechnologyAndOthers8 === null ? 0 : data.diplomaHolderInEngineeringTechnologyAndOthers8}

                                                                                </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                    {data.otherProfessional9 === null ? 0 : data.otherProfessional9}

                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                    {data.total10 === null ? 0 : data.total10}

                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                    {details.below10thClass3t2 === null ? 0 : details.below10thClass3t2}


                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >

                                                                                    {details._10thClassPassed4t2 === null ? 0 : details._10thClassPassed4t2}

                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                    {details._102Passed5t2 === null ? 0 : details._102Passed5t2}


                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                                                                                    {details.graduate6t2 === null ? 0 : details.graduate6t2}

                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                    <label> {details.postGraduate7t2 === null ? 0 : details.postGraduate7t2}</label>
                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                    {details.diplomaHolderInEngineeringTechnologyAndOthers8t2 === null ? 0 : details.diplomaHolderInEngineeringTechnologyAndOthers8t2}

                                                                                </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                    {details.otherProfessional9t2 === null ? 0 : details.otherProfessional9t2}

                                                                                </td>
                                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                    {details.total10t2 === null ? 0 : details.total10t2}

                                                                                </td></>:
                                                                        <>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {data.below10thClass3 === null ? 0 : data.below10thClass3}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >

                                                                                {data._10thClassPassed4 === null ? 0 : data._10thClassPassed4}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {data._102Passed5 === null ? 0 : data._102Passed5}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                                                                                {data.graduate6 === null ? 0 : data.graduate6}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                <label> {data.postGraduate7 === null ? 0 : data.postGraduate7}</label>
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.diplomaHolderInEngineeringTechnologyAndOthers8 === null ? 0 : data.diplomaHolderInEngineeringTechnologyAndOthers8}

                                                                            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.otherProfessional9 === null ? 0 : data.otherProfessional9}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.total10 === null ? 0 : data.total10}

                                                                            </td></>)}
                                                                    
                                                                   
                                                                    
                                                                </>
                                                                


                                                            )}
                                                        </tr>
                                                    ) : <h3>No Data Found</h3>) : <Spinner color="success" />}



                                            </tbody>
                                        </table>

                                    </div>



                                    </div>

                                </div>
                                {Statee.length > 0 && (
                                    <PaginationComponent
                                        noDown
                                        itemPerPage={itemPerPage}
                                        totalItems={DataCount}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                        EmploymentRefId={2}
                                        UserId={formData.state}
                                        MonthId={formData.month}
                                        YearId={formData.year}
                                        ToYearId={formData.toyear}
                                        ToMonthId={formData.tomonth}
                                        setStatee={setStatee}
                                        setmodal={setmodal}
                                        setload={setload}
                                    />
                                )}
                            </>}




                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ES2DataReport;
